import React from "react";
import type { SrChatChart } from "./sr-chat-chart-types";
import { SrChatBarChart } from "./sr-chat-bar-chart";

type Props = { charts?: SrChatChart[] };

export const SrChatCharts: React.FC<Props> = ({ charts }) => {
    if (!charts?.length) return null;
    return (
        <div className="space-y-2">
            {charts.map((chart) => (
                <SrChatBarChart key={chart.id} chart={chart} />
            ))}
        </div>
    );
};
